import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();

  return (
    <div className="page-not-found">
      <h2>Oops!</h2>
      <p>It appears the page you are looking for doesn't exist</p>
      <span>ERROR CODE 404</span>
      <button onClick={() => navigate(-1)}>Go Back</button>
    </div>
  );
};

export default Error;
